<template>
  <el-container style="height: 100vh">
    <el-aside width="220px">
      <el-menu :default-active="$route.path" router :default-openeds="defaultOpeneds">
        <template v-for="item in menuList">
          <!-- 一级菜单项（无子菜单） -->
          <el-menu-item v-if="!item.children && hasPermission(item.perm) && !(item.agentHide && isAgent)" :index="item.path" :key="item.path">
            <i :class="item.icon"></i>
            <span slot="title">{{ item.title }}</span>
          </el-menu-item>
          <!-- 一级菜单组（有子菜单） -->
          <el-submenu v-else-if="item.children && hasPermission(item.perm) && !(item.agentHide && isAgent)" :index="item.path" :key="item.path">
            <template slot="title">
              <i :class="item.icon"></i>
              <span>{{ item.title }}</span>
            </template>
            <template v-for="sub in item.children">
              <!-- 二级菜单项（无子菜单） -->
              <el-menu-item v-if="!sub.children && hasPermission(sub.perm)" :index="sub.path" :key="sub.path">
                <i :class="sub.icon"></i>
                <span slot="title">{{ sub.title }}</span>
              </el-menu-item>
              <!-- 二级菜单组（有子菜单） -->
              <el-submenu v-else-if="sub.children && hasPermission(sub.perm)" :index="sub.path" :key="sub.path">
                <template slot="title">
                  <i :class="sub.icon"></i>
                  <span>{{ sub.title }}</span>
                </template>
                <el-menu-item v-for="sub2 in sub.children" v-if="hasPermission(sub2.perm)" :index="sub2.path" :key="sub2.path">
                  <i :class="sub2.icon"></i>
                  <span slot="title">{{ sub2.title }}</span>
                </el-menu-item>
              </el-submenu>
            </template>
          </el-submenu>
        </template>
        <el-menu-item @click="openShanyanAdmin">
          <i class="el-icon-sunny"></i>
          <span slot="title">闪颜管理</span>
        </el-menu-item>
        <el-menu-item @click="handleLogout">
          <i class="el-icon-switch-button"></i>
          <span slot="title">退出登录</span>
        </el-menu-item>
      </el-menu>
    </el-aside>
    <el-main>
      <router-view/>
    </el-main>
  </el-container>
</template>

<script>
import { PERMISSIONS } from '@/config/permissions'

export default {
  name: "MainLayout",
  data() {
    return {
      PERMISSIONS,
      defaultOpeneds: ['/groupchat', '/activity', '/system'],
      menuList: [
        { path: '/', title: '数据总览', icon: 'el-icon-s-home', perm: PERMISSIONS.DASHBOARD_VIEW },
        { path: '/data-screen', title: '数据大屏', icon: 'el-icon-data-board' },
        { path: '/userList', title: '用户管理', icon: 'el-icon-user', perm: PERMISSIONS.USER_LIST },
        {
          path: '/platform', title: '微信开放平台', icon: 'el-icon-s-platform', perm: PERMISSIONS.PLATFORM_VIEW,
          children: [
            { path: '/platform/platform-list', title: '平台列表', icon: 'el-icon-menu', perm: PERMISSIONS.PLATFORM_VIEW },
            { path: '/platform/app-list', title: '应用列表', icon: 'el-icon-menu', perm: PERMISSIONS.PLATFORM_VIEW },
            { path: '/platform/template-list', title: '模板消息列表', icon: 'el-icon-message', perm: PERMISSIONS.PLATFORM_VIEW },
            { path: '/platform/media-list', title: '媒体素材', icon: 'el-icon-picture-outline', perm: PERMISSIONS.PLATFORM_VIEW },
          ]
        },
        {
          path: '/other-platforms', title: '其它平台', icon: 'el-icon-cloudy', perm: PERMISSIONS.OTHER_PLATFORM_VIEW,
          children: [
            {
              path: '/other-platforms/baidu', title: '百度', icon: 'el-icon-box', perm: PERMISSIONS.OTHER_PLATFORM_VIEW,
              children: [
                { path: '/other-platforms/baidu/speech-synthesis', title: '语音合成', icon: 'el-icon-microphone', perm: PERMISSIONS.OTHER_PLATFORM_VIEW },
              ]
            },
            {
              path: '/other-platforms/douyin', title: '抖音', icon: 'el-icon-video-camera', perm: PERMISSIONS.OTHER_PLATFORM_VIEW,
              children: [
                { path: '/other-platforms/douyin/account-list', title: '账号管理', icon: 'el-icon-user', perm: PERMISSIONS.OTHER_PLATFORM_VIEW },
              ]
            },
            {
              path: '/other-platforms/object-storage', title: '对象存储', icon: 'el-icon-upload', perm: PERMISSIONS.OTHER_PLATFORM_VIEW,
              children: [
                { path: '/other-platforms/object-storage/server-manage', title: '服务器管理', icon: 'el-icon-s-promotion', perm: PERMISSIONS.OTHER_PLATFORM_VIEW },
                { path: '/other-platforms/object-storage/file-manage', title: '文件管理', icon: 'el-icon-document', perm: PERMISSIONS.OTHER_PLATFORM_VIEW },
              ]
            },
          ]
        },
        { path: '/agent/list', title: '分公司管理', icon: 'el-icon-s-custom', perm: PERMISSIONS.AGENT_LIST, agentHide: true },
        {
          path: '/agent', title: '推广管理', icon: 'el-icon-user', perm: PERMISSIONS.AGENT_LIST,
          children: [
            { path: '/agent/promoter', title: '代理管理', icon: 'el-icon-s-check', perm: PERMISSIONS.AGENT_LIST },
            { path: '/agent/promoter-manage', title: '推广员管理', icon: 'el-icon-s-custom', perm: PERMISSIONS.AGENT_LIST },
            { path: '/agent/exchange-code-generate', title: '兑换码生成', icon: 'el-icon-tickets', perm: PERMISSIONS.EXCHANGE_CODE_GENERATE },
            { path: '/agent/exchange-code-list', title: '兑换码查询', icon: 'el-icon-search', perm: PERMISSIONS.EXCHANGE_CODE_LIST },
            { path: '/agent/join-setting', title: '加入设置', icon: 'el-icon-setting', perm: PERMISSIONS.AGENT_JOIN_SETTING },
            { path: '/agent/limit-setting', title: '推广设置', icon: 'el-icon-s-tools', perm: PERMISSIONS.AGENT_LIMIT_SETTING },
          ]
        },
        { path: '/qrcode/list', title: '二维码管理', icon: 'el-icon-tickets', perm: PERMISSIONS.QRCODE_LIST },
        {
          path: '/order', title: '订单管理', icon: 'el-icon-document', perm: PERMISSIONS.ORDER_VIEW,
          children: [
            { path: '/order/play', title: '陪玩订单', icon: 'el-icon-headset', perm: PERMISSIONS.ORDER_PLAY },
            { path: '/order/chater', title: '陪聊订单', icon: 'el-icon-chat-dot-round', perm: PERMISSIONS.ORDER_CHATER },
            { path: '/order/album', title: '相册订单', icon: 'el-icon-picture', perm: PERMISSIONS.ORDER_ALBUM },
          ]
        },
        {
          path: '/finance', title: '财务管理', icon: 'el-icon-money', perm: PERMISSIONS.FINANCE_VIEW,
          children: [
            { path: '/finance/trade', title: '支付交易列表', icon: 'el-icon-tickets', perm: PERMISSIONS.FINANCE_TRADE },
            { path: '/finance/cash', title: '提现列表', icon: 'el-icon-bank-card', perm: PERMISSIONS.FINANCE_CASH },
            { path: '/finance/refund-review', title: '退款审核', icon: 'el-icon-refresh-left', perm: PERMISSIONS.FINANCE_REFUND_REVIEW },
            // 旧分润体系菜单已隐藏（收益分配设置/闪颜分利配置/分润列表/分润明细/闪颜分润明细），由统一分润V2代替；页面与数据保留，可直接访问URL查看
            { path: '/finance/profit-v2-scheme', title: '分润方案管理', icon: 'el-icon-set-up', perm: PERMISSIONS.FINANCE_PROFIT_CONFIG },
            { path: '/finance/profit-v2-bind', title: '达人分润绑定', icon: 'el-icon-connection', perm: PERMISSIONS.FINANCE_PROFIT_CONFIG },
            { path: '/finance/profit-v2-record', title: '分润明细V2', icon: 'el-icon-document', perm: PERMISSIONS.FINANCE_PROFIT_RECORD },
          ]
        },
        { path: '/chater-manage/user-list', title: '陪聊管理', icon: 'el-icon-user', perm: PERMISSIONS.CHATER_LIST },
        {
          path: '/play', title: '陪玩管理', icon: 'el-icon-service', perm: PERMISSIONS.PLAY_VIEW,
          children: [
            { path: '/play/user-list', title: '陪玩用户列表', icon: 'el-icon-user', perm: PERMISSIONS.PLAY_USER_LIST },
            { path: '/play/item-list', title: '陪玩项目管理', icon: 'el-icon-menu', perm: PERMISSIONS.PLAY_ITEM_LIST },
            { path: '/play/category-list', title: '陪玩类别管理', icon: 'el-icon-s-grid', perm: PERMISSIONS.PLAY_CATEGORY_LIST },
            { path: '/play/comment-list', title: '达人评论管理', icon: 'el-icon-chat-dot-round', perm: PERMISSIONS.PLAY_COMMENT_LIST },
          ]
        },
        {
          path: '/marketing', title: '营销管理', icon: 'el-icon-present', perm: PERMISSIONS.MARKETING_VIEW,
          children: [
            { path: '/marketing/coupon-list', title: '优惠券', icon: 'el-icon-s-ticket', perm: PERMISSIONS.MARKETING_COUPON },
            { path: '/marketing/giftpack-list', title: '礼包', icon: 'el-icon-present', perm: PERMISSIONS.MARKETING_GIFTPACK },
            { path: '/marketing/promo-code', title: '推广码', icon: 'el-icon-share', perm: PERMISSIONS.MARKETING_PROMO },
          ]
        },
        {
          path: '/order-publish', title: '发单管理', icon: 'el-icon-document-add', perm: PERMISSIONS.ORDER_PUBLISH_VIEW,
          children: [
            { path: '/order-publish/list', title: '发单列表', icon: 'el-icon-document', perm: PERMISSIONS.ORDER_PUBLISH_LIST },
            { path: '/order-publish/nearby', title: '发单附近达人', icon: 'el-icon-user', perm: PERMISSIONS.ORDER_PUBLISH_NEARBY },
          ]
        },
        { path: '/cities/list', title: '城市管理', icon: 'el-icon-location', perm: PERMISSIONS.CITY_LIST },
        {
          path: '/groupchat', title: '闪颜群聊', icon: 'el-icon-chat-dot-round', perm: PERMISSIONS.GROUPCHAT_LIST,
          children: [
            { path: '/groupchat/shanyan-group', title: '闪颜社群管理', icon: 'el-icon-chat-square', perm: PERMISSIONS.GROUPCHAT_LIST },
            { path: '/groupchat/owner-audit', title: '群主审核', icon: 'el-icon-user-solid', perm: PERMISSIONS.GROUPCHAT_LIST },
            { path: '/groupchat/fadan-manage', title: '订单管理', icon: 'el-icon-document', perm: PERMISSIONS.GROUPCHAT_LIST },
            { path: '/groupchat/shanyan-order-card', title: '订单消息管理', icon: 'el-icon-document-copy', perm: PERMISSIONS.GROUPCHAT_LIST },
            { path: '/groupchat/quick-phrase', title: '快捷语管理', icon: 'el-icon-message', perm: PERMISSIONS.GROUPCHAT_LIST },
            { path: '/groupchat/moment-manage', title: '动态管理', icon: 'el-icon-picture', perm: PERMISSIONS.GROUPCHAT_LIST },
            { path: '/groupchat/vip-order', title: 'VIP购买记录', icon: 'el-icon-money', perm: PERMISSIONS.GROUPCHAT_LIST },
            { path: '/groupchat/private-message', title: '私信记录', icon: 'el-icon-message', perm: PERMISSIONS.GROUPCHAT_PRIVATE_MESSAGE },
            { path: '/groupchat/player-bot', title: '达人机器人', icon: 'el-icon-cpu', perm: PERMISSIONS.GROUPCHAT_LIST },
          ]
        },
        {
          path: '/content-safe', title: '内容安全', icon: 'el-icon-warning-outline', perm: PERMISSIONS.SYSTEM_VIEW,
          children: [
            { path: '/content-safe/sensitive-word', title: '敏感词管理', icon: 'el-icon-edit', perm: PERMISSIONS.SYSTEM_VIEW },
            { path: '/content-safe/report-handle', title: '举报处理', icon: 'el-icon-document-checked', perm: PERMISSIONS.SYSTEM_VIEW },
          ]
        },
        {
          path: '/activity', title: '活动管理', icon: 'el-icon-s-flag', perm: PERMISSIONS.ACTIVITY_VIEW,
          children: [
            { path: '/activity/organizer-audit', title: '主理人审核', icon: 'el-icon-user', perm: PERMISSIONS.ACTIVITY_VIEW },
            { path: '/activity/list', title: '活动列表', icon: 'el-icon-tickets', perm: PERMISSIONS.ACTIVITY_VIEW },
            { path: '/activity/registrations', title: '报名管理', icon: 'el-icon-document', perm: PERMISSIONS.ACTIVITY_VIEW },
            { path: '/activity/organizer-list', title: '主理人列表', icon: 'el-icon-user-solid', perm: PERMISSIONS.ACTIVITY_VIEW },
          ]
        },
        { path: '/message-manage', title: '留言管理', icon: 'el-icon-chat-line-round', perm: PERMISSIONS.MESSAGE_LIST },
        {
          path: '/audit-manage', title: '审核管理', icon: 'el-icon-document-checked', perm: PERMISSIONS.AUDIT_VIEW,
          children: [
            { path: '/audit-manage/player', title: '达人审核', icon: 'el-icon-user', perm: PERMISSIONS.AUDIT_PLAYER },
            { path: '/audit-manage/file', title: '文件审核', icon: 'el-icon-document', perm: PERMISSIONS.AUDIT_FILE },
            { path: '/audit-manage/order-publish', title: '发单审核', icon: 'el-icon-document-add', perm: PERMISSIONS.AUDIT_ORDER_PUBLISH },
          ]
        },
        {
          path: '/video-manage', title: '达人视频', icon: 'el-icon-video-camera', perm: PERMISSIONS.VIDEO_MANAGE,
          children: [
            { path: '/video-manage/audit', title: '视频审核', icon: 'el-icon-document-checked', perm: PERMISSIONS.VIDEO_AUDIT },
            { path: '/video-manage/upload', title: '上传视频', icon: 'el-icon-upload', perm: PERMISSIONS.VIDEO_UPLOAD },
            { path: '/video-manage/query', title: '视频管理', icon: 'el-icon-search', perm: PERMISSIONS.VIDEO_QUERY },
          ]
        },
        {
          path: '/trace', title: '轨迹查询', icon: 'el-icon-location-information', perm: PERMISSIONS.TRACE_VIEW,
          children: [
            { path: '/trace/city-cooperation', title: '城市合作', icon: 'el-icon-office-building', perm: PERMISSIONS.TRACE_VIEW },
          ]
        },
        {
          path: '/front-config', title: '前端设置', icon: 'el-icon-monitor',
          children: [
            { path: '/front-config/home', title: '首页设置', icon: 'el-icon-house', perm: PERMISSIONS.SYSTEM_FRONT_CONFIG },
            { path: '/front-config/fee-setting', title: '费用设置', icon: 'el-icon-money', perm: PERMISSIONS.SYSTEM_FRONT_CONFIG },
          ]
        },
        {
          path: '/system', title: '系统管理', icon: 'el-icon-setting', perm: PERMISSIONS.SYSTEM_VIEW,
          children: [
            { path: '/system/admin-list', title: '管理员列表', icon: 'el-icon-user', perm: PERMISSIONS.SYSTEM_ADMIN_LIST },
            { path: '/system/staff-list', title: '员工管理', icon: 'el-icon-user-solid', perm: PERMISSIONS.SYSTEM_STAFF_LIST },
            { path: '/system/branch-role', title: '角色管理', icon: 'el-icon-s-custom', perm: PERMISSIONS.SYSTEM_BRANCH_ROLE_LIST },
            { path: '/system/message-notify-manage', title: '消息提示管理', icon: 'el-icon-bell', perm: PERMISSIONS.SYSTEM_NOTIFY },
            { path: '/system/message-receiver-manage', title: '消息管理', icon: 'el-icon-message', perm: PERMISSIONS.SYSTEM_MESSAGE_RECEIVER },
            { path: '/system/message-template-manage', title: '模板链接管理', icon: 'el-icon-link', perm: PERMISSIONS.SYSTEM_MESSAGE_TEMPLATE },
            { path: '/system/tag-manage', title: '标签管理', icon: 'el-icon-collection-tag', perm: PERMISSIONS.SYSTEM_TAG },
            {
              path: '/system/keyword-manage', title: '关键字管理', icon: 'el-icon-edit', perm: PERMISSIONS.SYSTEM_KEYWORD,
              children: [
                { path: '/system/keyword-manage/list', title: '列表', icon: 'el-icon-tickets', perm: PERMISSIONS.SYSTEM_KEYWORD },
                { path: '/system/keyword-manage/edit', title: '编辑', icon: 'el-icon-edit', perm: PERMISSIONS.SYSTEM_KEYWORD },
              ]
            },
            { path: '/system/password', title: '修改操作码', icon: 'el-icon-key', perm: PERMISSIONS.SYSTEM_PASSWORD },
            { path: '/system/share-config', title: '分享配置', icon: 'el-icon-picture', perm: PERMISSIONS.SYSTEM_SHARE_CONFIG },
            { path: '/system/test', title: '测试页面', icon: 'el-icon-s-tools', perm: PERMISSIONS.SYSTEM_VIEW },
            { path: '/system/role-permission', title: '角色权限管理', icon: 'el-icon-lock', perm: PERMISSIONS.SYSTEM_ROLE_PERM },
            { path: '/system/vip-price', title: '会员价格', icon: 'el-icon-ticket', perm: PERMISSIONS.SYSTEM_VIP_PRICE },
            { path: '/system/fare-config', title: '路费配置', icon: 'el-icon-truck', perm: PERMISSIONS.SYSTEM_VIEW },
            { path: '/system/withdraw-config', title: '提现管理', icon: 'el-icon-money', perm: PERMISSIONS.SYSTEM_WITHDRAW_CONFIG },
            { path: '/system/page-hotspot', title: '页面热区配置', icon: 'el-icon-picture-outline', perm: PERMISSIONS.SYSTEM_PAGE_HOTSPOT },
            { path: '/system/page-setting', title: '页面设置', icon: 'el-icon-monitor', perm: PERMISSIONS.SYSTEM_VIEW },
            { path: '/system/customer-service', title: '客服管理', icon: 'el-icon-service', perm: PERMISSIONS.CUSTOMER_SERVICE_LIST },
            { path: '/system/data-screen-config', title: '大屏数据配置', icon: 'el-icon-setting' },
          ]
        },
      ]
    }
  },
  computed: {
    userInfo() {
      // Vuex getter 获取当前登录用户
      const info = this.$store.getters['user/userInfo'] || {};
      return info;
    },
    isSuperAdmin() {
      return (
          this.userInfo.sys_admin &&
          [1, 4].includes(this.userInfo.sys_admin.role)
      );
    },
    isAgent() {
      return (
          this.userInfo.sys_admin &&
          this.userInfo.sys_admin.role === 5
      );
    },
    permissions() {
      return this.$store.getters['user/permissions'] || [];
    }
  },
  methods: {
    hasPermission(code) {
      if (this.isSuperAdmin) return true;
      if (!code) return true;
      const perms = this.permissions || [];

      // 兼容旧版存储的 permissions 字符串数组/对象数组
      return perms.some(p => {
        if (typeof p === 'string') return p === code;
        return p && (p.code === code || p === code);
      });
    },
    openShanyanAdmin() {
      // 在新标签页打开新版闪颜管理后台（部署在 b.app 子目录）
      const url = 'https://b.app.yukevip.club/shanyan-admin';
      window.open(url, '_blank');
    },
    handleLogout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 1. 清除本地 token
        localStorage.removeItem('molv_token');
        // 2. 清空 store 用户数据
        this.$store.dispatch('user/logout');
        // 3. 跳转到登录页
        this.$router.replace({path: '/login'});
      });
    }
  }
};
</script>

